import _environment from "../internals/environment";
var exports = {};
var ENVIRONMENT = _environment;
exports = ENVIRONMENT === "NODE";
export default exports;